export default "__VITE_ASSET__BS$kmCaM__"